import {
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
} from "../../../../../helpers";

const displayCancelMessage = (status: string): void => {
  switch (status) {
    case "PROCESSING":
      showWarningMessage(
        "O cancelamento está em processamento e pode levar até 10 minutos para concluir!",
      );
      break;
    case "FAILED":
      showErrorMessage("Houve um erro ao tentar cancelar a nota");
      break;
    case "RECURRENCE":
      showSuccessMessage("Recorrência cancela com sucesso");
      break;
    default:
      showSuccessMessage("Nota cancelada com Sucesso!");
  }
};

export default displayCancelMessage;
